export var hiMedicalTariffKind = ['HiMedical', 'HiMedicalPlus'];
export var EMPLOYMENT_STATUSES = [
    'EMPLOYED_IN_GERMANY',
    'EMPLOYED_OUTSIDE_OF_GERMANY',
    'SELF_EMPLOYED',
    'OTHER',
];
export var ACTIVE_TARIFFS = [
    'NKSelectS',
    'NKSelectL',
    'NKSelectXL',
    'HiMedical',
    'HiMedicalPlus',
];
export var defaultAddonsLookup = {
    NKSelectS: ['KT', 'NKSFLEX'],
    NKSelectL: ['KT'],
    NKSelectXL: ['KT'],
    HiMedical: ['KT', 'HD'],
    HiMedicalPlus: ['KT', 'HDL'],
    NK: ['KT'],
    KS: ['KT'],
    Primo: ['KT'],
    PrimoPlus: ['KT'],
    'NLTN.': [],
};
export var defaultDeductiblesLookup = {
    HiMedical: '500',
    HiMedicalPlus: '500',
    NKSelectS: '0',
    NKSelectL: '0',
    NKSelectXL: '0',
    NK: '0',
    KS: '0',
    Primo: '0',
    PrimoPlus: '0',
    'NLTN.': '0',
};
export var cashbackLookup = {
    NKSelectS: 100,
    NKSelectL: 100,
    NKSelectXL: 100,
    HiMedical: 0,
    HiMedicalPlus: 0,
};
